// import { accordion } from "./accordion";

export let hidedropdown = function () {

  $("td[colspan=5]").find("div.accordion-content-container").hide();

}

export let companydropdown = function() {

  $(function() {
    $("tr.accordion").click(function(event) {
        var $target = $(event.target);
            $target.closest("tr").next().find("div.accordion-content-container").slideToggle();
          
          $(this).toggleClass('expanded');
          if($(this).hasClass('expanded')) {
            $(this).attr('aria-expanded', true)
            $(this).attr('aria-label', "table panel expanded")
            $('.table-accordion').attr("aria-expanded", true);
            $('.table-accordion').attr("aria-label", "click to collapse accordion with more information")
            // $('.table-accordion').css({"position": "relative"});
            // $('td.company-description').css({"display": "none"});
            // $('button.table-accordion').css({"position": "absolute"})
          } else if ($(this).hasClass('expanded') == false) {
            $(this).attr("aria-expanded", false);
            $('.table-accordion').attr("aria-expanded", false);
            $('.table-accordion').attr("aria-label", "click to expand accordion for more information")
            $(this).attr('aria-label', "table panel collapsed")
            // $('td.company-description').css({"display": "block"});
          }
    });
  });

}